import React, { useState } from "react";
import { useForm } from "react-hook-form";
import {
  Box,
  Button,
  FormControl,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import Loader from "components/loader/Loader";
import { handleValidationForm } from "utils/utils";

export default function CommonForm(props) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    clearErrors,
  } = useForm({ defaultValues: props?.defaultValues });
  const [formError, setFormError] = useState([]);
  const [isDisabled, setIsDisabled] = useState(
    props?.selectType === "edit" ? false : true
  );

  const formData = props?.formData ? props?.formData : [];

  const handleInput = (e, value) => {
    clearErrors(e.target.name);
    const data = {};

    if (value && value !== undefined) {
      data[e.target.name] = value;
    } else {
      data[e.target.name] = e.target.value;
    }
    let validationData = handleValidationForm(data);
    setFormError(validationData.errorVal);
    if (validationData.formIsValid) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  };

  // ---Form Validation---

  const onSubmit = (data) => {
    props.onSubmittBtn(data, reset);
  };

  return (
    <div className="commonForm">
      {/* "handleSubmit" will validate your inputs before invoking "onSubmit"  */}
      <form onSubmit={handleSubmit(onSubmit)}>
        {formData?.map((ele, idx) => (
          <div key={idx}>
            <Box
              display={"grid"}
              gap={3}
              sx={{
                marginBlock: { xs: "0px", sm: "10px" },
              }}
              key={ele?.name}
            >
              <FormControl variant="standard">
                <p className="commonformLabel colorPrimary">
                  {ele?.label}
                  {ele?.required && (
                    <span className="colorRed">{ele?.star || "*"}</span>
                  )}
                </p>
                <Box className="flexDisplay loginForm">
                  <TextField
                    placeholder={ele?.placeholder}
                    {...register(ele?.name, {
                      required: ele?.required || false,
                      onChange: (e) => {
                        handleInput(e);
                      },
                    })}
                    rows={ele?.row || 1}
                    multiline = {ele?.multiline || false}
                    type={ele?.type}
                    
                    inputProps={{
                      maxLength: ele?.maxlength,
                    }}
                    error={!!(errors[ele?.name] || formError[ele?.name])}
                  />
                </Box>
                {/* errors will return when field validation fails  */}
                {errors[ele?.name] && (
                  <div className="errorMessage">This field is required</div>
                )}
                {formError[ele?.name] && (
                  <div className="errorMessage">{formError[ele?.name]}</div>
                )}
              </FormControl>
            </Box>
          </div>
        ))}
        {props?.button && (
          <Box>
            <Grid container>
              <Grid item xs={12}>
                <Button
                  size="medium"
                  className={`buttonSubmit ${
                    isDisabled ? "buttonSubmitDisabled" : ""
                  }`}
                  type="submit"
                  fullWidth
                  disabled={isDisabled || props?.disabled}
                >
                  {props.loading ? (
                    <Loader />
                  ) : (
                    <Typography variant="body1" className="colorWhite">
                      {props?.button}
                    </Typography>
                  )}
                </Button>
              </Grid>
            </Grid>
          </Box>
        )}
      </form>
    </div>
  );
}
